<template lang="pug">
.view-handbooks.content
  b-navbar.ui-navbar-secondary.is-primary()
    template(#start)
      b-navbar-item(tag="router-link" :to="{name:'tags'}") Метки

  router-view

</template>

<script>
export default {
  name: 'view-handbooks',

  data: () => ({}),
};
</script>
